import { createPromiseControllers } from '../../../common/v5/helpers';
import { clearInsertionText, insertText } from '../cke';
import { wrapProtectReplyContentMarker } from '../common';

const [
    insertionTextStart
    , insertionTextControl
] = createPromiseControllers();

const stripInlineFontStyles = html => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    const elementsWithStyle = tempDiv.querySelectorAll('[style]');
    elementsWithStyle.forEach(el => {
        const style = el.getAttribute('style');
        if (!style) {
            return;
        }

        const remainingStyles = style
            .split(';')
            .map(part => part.trim())
            .filter(part => {
                const property = part.split(':')[0];
                if (!property) {
                    return false;
                }

                const normalizedProperty = property.trim().toLowerCase();
                return normalizedProperty !== 'font-family'
                    && normalizedProperty !== 'font-size';
            });

        if (remainingStyles.length) {
            el.setAttribute('style', remainingStyles.join('; '));
        } else {
            el.removeAttribute('style');
        }
    });

    const fontTags = tempDiv.querySelectorAll('font[face], font[size]');
    fontTags.forEach(font => {
        font.removeAttribute('face');
        font.removeAttribute('size');
    });

    return tempDiv.innerHTML;
};

export const insertContent = text => dispatch => {
    const p = insertionTextStart(true);

    if (typeof text === 'string' && text.indexOf('<') !== -1) {
        dispatch(insertText(stripInlineFontStyles(text)));
    } else {
        dispatch(insertText(text));
    }
    return p;
};

export const insertProtectedReplyContent = text => (
	dispatch
	, getState
) => dispatch(insertContent(wrapProtectReplyContentMarker(text, getState())));

export const clearInsertionContent = () => dispatch => {
    dispatch(clearInsertionText());
    insertionTextControl();
};
